define(
	'MHI.AddressCustomization.Utils'
,   [
		'MHI.AddressCustomization.SaveAddress.SS2Model',
		'underscore'
	]
,   function (
		SS2Model,
		_
	)
{
	'use strict';

	return  {
		getAddressList: function(attribute, callback){
			var model = new SS2Model();
			model.fetch(attribute).done(function(response){
				if(callback){
					callback(response);
				}
			})
		},

		filterSavedForLaterAddress: function(addresses, saveForLaterData){
			return _.filter(addresses, function(address){
				if(address.get('internalid') != -1){
					var selectedAddress = _.find(saveForLaterData, function(addr){
						return addr.id == address.get('internalid');
					});
					if(selectedAddress && selectedAddress.saveForLater){
						return address;
					}
				}else{
					return address;
				}
			});
		},

		resetProfileAddresses: function(profileShipAddress, profileBillAddress){
			var dataToSend = {revertDefaultAddresses: true};

			if(!_.isEmpty(window.sessionStorage.getItem('shipaddress')) && profileShipAddress.internalid !== window.sessionStorage.getItem('shipaddress')){
				dataToSend.updateShipAddress = true;
				dataToSend.defaultShipAddress = window.sessionStorage.getItem('shipaddress')
			}
			if(!_.isEmpty(window.sessionStorage.getItem('billaddress')) && profileBillAddress.internalid !== window.sessionStorage.getItem('billaddress')){
				dataToSend.updateBillAddress = true;
				dataToSend.defaultBillAddress = window.sessionStorage.getItem('billaddress')
			}

			if(dataToSend.updateShipAddress || dataToSend.updateBillAddress){
				var model = new SS2Model();
				model.fetch({
					data: dataToSend
				}).done(function(response){
					if(response && response.success){
						window.sessionStorage.setItem('shipaddress', '')
						window.sessionStorage.setItem('billaddress', '')
					}
				})
			}
		}
	};
});
